"use client";

import Image from "next/image";
import { useState } from "react";
import { ImageLightbox } from "./ImageLightbox";

interface HeroImageProps {
  src: string;
  alt?: string;
}

export function HeroImage({ src, alt = "SENSEI interface" }: HeroImageProps) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <div
        className="sol-hero-img-wrap"
        onClick={() => setOpen(true)}
        role="button"
        tabIndex={0}
        aria-label="View full-size image"
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setOpen(true); }}
      >
        <Image
          src={src}
          alt={alt}
          width={1920}
          height={1080}
          sizes="(max-width: 768px) 100vw, 960px"
          className="sol-hero-img"
          priority
        />
      </div>

      {open && (
        <ImageLightbox src={src} alt={alt} onClose={() => setOpen(false)} />
      )}
    </>
  );
}
